export class SlotMachine {
    constructor($root, options = {}) {
        this.$root = $root;
        this.$reels = null;

        this.height = 510;
        this.tMax = options.tMax || 2000;
        this.speeds = [];
        this.r = [];
        this.numberOutput = [];
        this.target = null;
        this.sTarget = null;
        this.reels = [
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
        ];
        this.start = null;
    }

    init(target, result) {
        if (!this.$root) {
            return;
        }

        this.$reels = this.$root.querySelectorAll('.reel');

        this.reels = Array.from(this.$reels).map(($reel) => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']);

        if (result) {
            this.$root.classList.remove('-initial');
            this.$reels.forEach(($reel, i) => {
                const resultSplitted = `${result}`.split('');
                $reel.textContent = resultSplitted[i];
            });

            return;
        }

        if (!target) {
            return;
        }

        this.updateTarget(target);
    }

    updateTarget(target) {
        this.target = target;
        this.sTarget = this.target.toString();

        if (this.sTarget.length < this.reels.length) {
            for (let i = 0; i <= (this.reels.length - this.sTarget.length); i++) {
                this.sTarget = '0' + this.sTarget;
            }
        }

        this.$reels.forEach(($reel, i) => {
            $reel.innerHTML = '<div class="reel-holder"><p>' +
                this.reels[i].join('</p><p>') +
                '</p></div><div class="reel-holder"><p>' +
                this.reels[i].join('</p><p>') +
                '</p></div><div class="reel-door">0</div>';
        });
    }

    updateTargetAndRun(target, options = {}) {
        if (!target) {
            return;
        }

        if (options.tMax) {
            this.tMax = options.tMax;
        }

        this.updateTarget(target);
        this.action();
    }

    action(callback) {
        if (this.start) {
            return;
        }

        this.$root.classList.remove('-initial');
        this.height = this.$reels[0].clientHeight * 10;

        const $reelDoors = this.$root.querySelectorAll('.reel-door');
        const $reelHolders = this.$root.querySelectorAll('.reel-holder');

        $reelDoors.forEach(($reelDoor) => {
            $reelDoor.classList.add('-hidden');
        });

        $reelHolders.forEach(($reelHolder) => {
            $reelHolder.classList.add('-show');
        })

        for (let i = 0; i < this.sTarget.length; i += 1) {
            const targetNum = (parseInt(+this.sTarget.charAt(i) | 0));
            const intOffset = targetNum * this.height / 10 - ((this.height / 10) * 2);
            this.numberOutput[i] = intOffset >= 0 ? intOffset : this.height - (this.height / 10) - (targetNum === 0 ? this.height / 10 : 0);
        }
        for (let j = 0; j < this.sTarget.length; ++j) {
            this.speeds[j] = Math.random() + .7;
            this.r[j] = (Math.random() * 10 | 0) * this.height / 10;
        }

        const animate = (now) => {
            if (!this.start) this.start = now;
            const t = now - this.start || 0;

            for (let i = 0; i < this.sTarget.length; ++i) {
                this.$reels[i].scrollTop = (this.speeds[i] / this.tMax / 2 * (this.tMax - t) * (this.tMax - t) + this.numberOutput[i]) % this.height | 0;
            }

            if (t < this.tMax) {
                requestAnimationFrame(animate);
            } else {
                this.start = undefined;

                if (callback) {
                    callback();
                }
            }
        }

        animate();
    }
}